var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { TraitConditionEvaluator } from './TraitConditionEvaluator';
import { TraitCondition } from '../condition/TraitCondition';
import { deserialize } from '../../../utils/serializr/serializr';
export class TraitConditionTopEvaluator extends TraitConditionEvaluator {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get attachedTrait() {
        return this.parent;
    }
    get traitCondition() {
        return this.attachedTrait.trait.condition;
    }
    createTraitCondition() {
        const newCondition = TraitCondition.fromSerialized({ parent: this.attachedTrait.trait });
        this.setTraitCondition(newCondition);
        return newCondition;
    }
    setTraitCondition(condition) {
        this.parent.trait.condition = condition;
    }
    static fromSerialized(ser = {}) {
        return deserialize(TraitConditionTopEvaluator, ser);
    }
}
__decorate([
    action.bound
], TraitConditionTopEvaluator.prototype, "createTraitCondition", null);
__decorate([
    action.bound
], TraitConditionTopEvaluator.prototype, "setTraitCondition", null);
